import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './Login/login/login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegistrationComponent } from './Login/registration/registration.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './security/auth.guard';
import { StoreModule, ActionReducer, MetaReducer } from '@ngrx/store';
import { reducer } from './state/user.reducer';
import { localStorageSync } from 'ngrx-store-localstorage';
import { WelcomeComponent } from './User/welcome/welcome.component';
import { UsermenuComponent } from './shared/usermenu/usermenu.component';
import { ForgotPasswordComponent } from './Login/forgot-password/forgot-password.component';
import { AdminModule } from './Admin/admin.module';
import { CommonModule } from './Common/common.module';
import { UploadFileComponent } from './popup/upload-file/upload-file.component';
import { FlowmeterListComponent } from './popup/flowmeter-list/flowmeter-list.component';
import { AddSiteComponent } from './popup/add-site/add-site.component';
import { SetParameterComponent } from './popup/set-parameter/set-parameter.component';
import { DatePipe } from '@angular/common';
import { EmailComponent } from './popup/email/email.component';
import { SetparameterFlowmeterComponent } from './popup/setparameter-flowmeter/setparameter-flowmeter.component';
import { UpdateParameterComponent } from './popup/update-parameter/update-parameter.component';
import { AssignCompanyComponent } from './popup/assigncompany/assign-company.component';
import { GSMConfigComponent } from './popup/gsmconfig/gsmconfig';
import { RegisterpanelComponent } from './popup/registerpanel/registerpanel';
import { SchedulereportComponent } from './popup/schedulereport/schedulereport';
import { JwtInterceptor } from './service/HttpInterceptor';
import { UserdashboarddetailsComponent } from './popup/userdashboarddetails/userdashboarddetails.component';
import { SetparameterthresoldvalueComponent } from './popup/setparameter-thresoldvalue/setparameter-thresoldvalue';
import { HomeComponent } from './shared/home/home.component';
import { AddnewdashboardComponent } from './popup/addnewdashboard/addnewdashboard.component';
import { AdddashboardComponent } from './popup/adddashboard/adddashboard.component';
import { AddnewreportComponent } from './popup/addnewreport/addnewreport.component';
import { DataSharingService } from './Service/datasharing.service';
import { ReportdatapopupComponent } from './popup/reportdatapopup/reportdatapopup.component';
import { AnalogRegisterpanelComponent } from './popup/analogregisterpanel/analogregisterpanel';
import { OwlModule } from 'ngx-owl-carousel';
import { LevelMonitoringComponent } from './Shared/home/level-monitoring/level-monitoring.component';
import { SaveRegisterControlValueComponent } from './popup/save-register-control-value/save-register-control-value.component';
import { FlowMonitoringComponent } from './Shared/home/flow-monitoring/flow-monitoring.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { AddnewparameterconfigComponent } from './popup/addnewparameterconfig/addnewparameterconfig.component';
import { ExportoptionpopupComponent } from './popup/exportoptionpopup/exportoptionpopup.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { ContactComponent } from './contact/contact.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BlogComponent } from './blog/blog.component';
import { LatestArticleComponent } from './latest-article/latest-article.component';
import { PredictiveMaintainanceComponent } from './Shared/home/predictive-maintainance/predictive-maintainance.component';
import { IiotSoftwarePlatformComponent } from './Shared/home/iiot-software-platform/iiot-software-platform.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { EnergyMonitoringComponent } from './Shared/home/energy-monitoring/energy-monitoring.component';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { AddNewGraphConfigComponent } from './popup/add-new-graph-config/add-new-graph-config.component';
import { NewFeaturesComponent } from './popup/new-features/new-features.component';
import { AnalogDigitalComponent } from './reportgrid/adminaddsite/analog-digital-popup/analog-digital-popup.component';
// import { ProcessassignmeterListComponent } from './popup/processassignmeter-list/processassignmeter-list.component';
import { GraphConfigReportNameComponent } from './popup/graph-config-report-name/graph-config-report-name.component';
import { VirtualRegisterpanelComponent } from './popup/virtualregisterpanel/virtualregisterpanel';
import { EditVirtualMeterComponent } from './popup/edit-virtual-meter/edit-virtual-meter.component';
import { LoadChartComponent } from './Admin/load-chart/load-chart.component';

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({ keys: ['userState'], rehydrate: true })(reducer);
  // ,
  // rehydrate: true
}

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    WelcomeComponent,
    UsermenuComponent,
    ForgotPasswordComponent,
    UploadFileComponent,
    FlowmeterListComponent,
    // ProcessassignmeterListComponent,
    AddSiteComponent,
    SetParameterComponent,
    EmailComponent,
    SetparameterFlowmeterComponent,
    AssignCompanyComponent,
    UpdateParameterComponent,
    GSMConfigComponent,
    RegisterpanelComponent,
    SchedulereportComponent,
    UserdashboarddetailsComponent,
    SetparameterthresoldvalueComponent,
    HomeComponent,
    AddnewdashboardComponent,
    AdddashboardComponent,
    AddnewreportComponent,
    ReportdatapopupComponent,
    NewFeaturesComponent,
    LevelMonitoringComponent,
    SaveRegisterControlValueComponent,
    FlowMonitoringComponent,
    AddnewparameterconfigComponent,
    EditVirtualMeterComponent,
    AddNewGraphConfigComponent,
    ExportoptionpopupComponent,
    ContactComponent,
    HeaderComponent,
    FooterComponent,
    BlogComponent,
    LatestArticleComponent,
    IiotSoftwarePlatformComponent,
    PredictiveMaintainanceComponent,
    AboutUsComponent,
    EnergyMonitoringComponent,
    AnalogDigitalComponent,
    AnalogRegisterpanelComponent,
    GraphConfigReportNameComponent,
    VirtualRegisterpanelComponent,
    LoadChartComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgxDocViewerModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    StoreModule,
    MatPaginatorModule,
    MatSortModule,
    StoreModule.forRoot({}, { metaReducers }),
    StoreModule.forFeature('userState', reducer),
    OwlModule,
  ],
  exports: [MatDatepickerModule, MatNativeDateModule],
  providers: [
    AuthGuard,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigurationsService) => () =>
        configService.loadConfigService(),
      deps: [ConfigurationsService],
      multi: true,
    },
    DataSharingService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    UploadFileComponent,
    NewFeaturesComponent,
    FlowmeterListComponent,
    // ProcessassignmeterListComponent,
    AddSiteComponent,
    SetParameterComponent,
    AssignCompanyComponent,
    UpdateParameterComponent,
    GSMConfigComponent,
    RegisterpanelComponent,
    SchedulereportComponent,
    UserdashboarddetailsComponent,
    SetparameterthresoldvalueComponent,
    AddnewdashboardComponent,
    AdddashboardComponent,
    AddnewreportComponent,
    ReportdatapopupComponent,
    SaveRegisterControlValueComponent,
    AnalogRegisterpanelComponent,
    GraphConfigReportNameComponent,
    VirtualRegisterpanelComponent,
    DataSharingService,
  ],
})
export class AppModule {}
